import { render, staticRenderFns } from "./AccountRequests.vue?vue&type=template&id=651fbfd4&"
import script from "./AccountRequests.vue?vue&type=script&lang=js&"
export * from "./AccountRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports